import { useState } from 'react';
import { useUIStore } from '@/stores';
import { authApi } from '@/api/client';
import { Mail, X, Loader } from 'lucide-react';

export function ForgotPasswordModal() {
  const { isForgotPasswordModalOpen, closeForgotPasswordModal } = useUIStore();
  
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (!isForgotPasswordModalOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email) {
      setError('请输入邮箱地址');
      return;
    }

    setIsLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSuccess('密码重置链接已发送到您的邮箱，请查收。');
      setTimeout(() => {
        closeForgotPasswordModal();
        setEmail('');
        setSuccess('');
      }, 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || '发送失败，请稍后重试');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    closeForgotPasswordModal();
    setEmail('');
    setError('');
    setSuccess('');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleClose} />
      
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[85vh] overflow-y-auto p-6">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">忘记密码？</h2>
          <p className="text-gray-500 text-sm">输入您的注册邮箱，我们会发送重置密码链接</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="relative mb-4">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <Mail className="w-5 h-5" />
            </div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 pl-11 pr-4 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder="请输入邮箱地址"
              required
            />
          </div>

          {error && (
            <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm text-center">{error}</div>
          )}
          {success && (
            <div className="mb-3 p-3 bg-green-50 border border-green-200 rounded-lg text-green-600 text-sm text-center">{success}</div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <Loader className="w-5 h-5 animate-spin" />
            ) : (
              '发送重置链接'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}